import Loadable from "react-loadable";

const LazyNextArrivals = Loadable({
  loader: () => import(/* webpackChunkName: 'list-next-arrivals' */ "./index"),
  loading: () => 'loading...'
});

export default LazyNextArrivals;
